import Typography from "@components/typography/Typography";
import styles from "./AppNotAvailable.module.scss";
import Button from "@components/button/Button";
import { useAuth } from "@components/auth-provider/AuthProvider";
import { marginBottom } from "~/reusableStyles/margin";
import PESLogo from "../../icons/PES_Logo.svg";

const browserType = () => {
  // Check useragent
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isMobile = isIOS || isAndroid;
  return { isMobile, isIOS, isAndroid };
};

export const AppNotAvailablePage = () => {
  const { isMobile, isIOS, isAndroid } = browserType();
  const auth = useAuth();
  const token = auth.getAuthToken();
  const mobileScheme = import.meta.env.VITE_MOBILE_SCHEME;
  return (
    <div className={`${styles.container} light`} data-theme="light">
      <img src={PESLogo} alt="PES Logo" css={marginBottom(24)} width={150} />
      <Typography variant="display" text="Sorry!" weight="bold" size="lg" />
      <Typography
        variant="display"
        size="sm"
        text="The PES web app is not yet available. Please check back soon."
      />
      <br />
      {isMobile && token && mobileScheme && (
        <>
          <Typography
            variant="display"
            size="sm"
            text="In the meantime, if you have the PES app installed, click the button below to log in."
          />
          <br />
          <Button
            text="Open PES App"
            onClick={() => {
              window.location.href = `${mobileScheme}://pes-noexc?token=${token}`;
            }}
            size="xxl"
            extraCss={{
              fontSize: 36,
              paddingVertical: 32,
              paddingHorizontal: 72,
            }}
          />
        </>
      )}
    </div>
  );
};
